module.exports = __webpack_public_path__ + "img/sauna_tent_2.bb0b3a3c.jpg";